export default "__VITE_ASSET__73f6abb4__"